// extracted by mini-css-extract-plugin
module.exports = {"upgradeDowngradeButton":"Prescribers_upgradeDowngradeButton__2jRHE"};